/** The query key a conversation's sign-in comes back with: the connection card it was started from. */
const CONNECTION_RETURN_QUERY_KEY = 'connected';

export default CONNECTION_RETURN_QUERY_KEY;
